var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'map-disabled': !_vm.$store.getters.isMapEnabled},attrs:{"id":"app-vue","dir":"ltr"}},[_c('MapUp'),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"mapupdate-analyze-identifier"}},[_vm._v(" "+_vm._s(_vm.analyzeIdentifier)+" ")]),_c('div',{staticStyle:{"min-height":"300px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }